import { createAction, props } from '@ngrx/store';

// Constants
import { ComplianceReportHistoryPageSortColumn } from 'FoldersApp/apps/compliance-report-history-app/constants';
// Interfaces / types
import { SortDirection } from 'Angular/types/sort-direction.type';
import { ComplianceReportData } from '../../interfaces/compliance-report-data.interface';
import {
    ComplianceDesignationTypeOptions,
    ComplianceReportTypeOptions,
} from 'FoldersApp/apps/compliance-report-history-app/interfaces/compliance-report-type-options.interface';

export const setComplianceReportHistoryStore = createAction(
    '[Compliance Report History Page] Set Report History Store',
    props<{
        data: ComplianceReportData;
        startDate: string | null;
        endDate: string | null;
        reportType: ComplianceReportTypeOptions;
        designationType: ComplianceDesignationTypeOptions;
        sortDirection: SortDirection;
        sortColumn: ComplianceReportHistoryPageSortColumn;
    }>()
);
